import { Injectable } from '@angular/core';
import { UserPermissionCodeEnum } from '@app/core/enums/user-permission-code.enum';
import { cloneDeep } from '@hal/common';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserFacade {
  private _userActionsSubject: Subject<boolean> = new Subject<boolean>();
  private _permissions: UserPermissionCodeEnum[] = [];

  /***
   * Observable to check if user has any actions
   */
  public hasUserActions$: Observable<boolean> = this._userActionsSubject.asObservable();

  /***
   * Check if user has any actions
   */
  public get hasUserActions(): boolean {
    return this._permissions.length > 0;
  }

  constructor() {}

  /***
   * Check if user has permission to do action
   * @param permissions
   */
  public canUserDoAction(permissions: UserPermissionCodeEnum[]): boolean {
    return this._permissions.some((permission) => permissions.includes(permission)) ?? false;
  }

  /***
   * Set user actions
   * @param permissions
   */
  public setUserActions(permissions: UserPermissionCodeEnum[]) {
    this._permissions = cloneDeep(permissions);
    this._userActionsSubject.next(true);
  }
}
